module.exports = new __parcel__URL__("cash.bb37225b.png").toString();